interface FoodGroup {
  title: string;
  foods: number[];
  background?: string;
  text: string;
}

const foodGroups: FoodGroup[] = [
  {
    title: "Fruit & Veg",
    foods: [2, 3],
    background: "#539635",
    text: "white",
  },
  {
    title: "Whole grains",
    foods: [0],
    background: "#f8b832",
    text: "black",
  },
  {
    title: "Starchy vegetables",
    foods: [1],
    background: "#834e3e",
    text: "white",
  },
  {
    title: "Dairy foods",
    foods: [4],
    background: "#47b5e0",
    text: "white",
  },
  {
    title: "Animal-sourced protein",
    foods: [5, 6, 7, 8],
    background: "#ed473e",
    text: "white",
  },
  {
    title: "Plant-sourced protein",
    foods: [9, 10],
    background: "#c6e0a6",
    text: "black",
  },
  {
    title: "Added fats",
    foods: [11, 12],
    background: "#f38e31",
    text: "white",
  },
  {
    title: "Added sugars",
    foods: [13],
    text: "black",
  },
];

export default foodGroups;
